import { GInformativeText, IconLogoLivelo } from '@gazin/ecommerce-ui'
import { singularOrPlural } from 'src/util/singularOrPlural'
import { ProductRewardsPointsProps } from '../index'

export default function LiveloProductCampaign(
  props: ProductRewardsPointsProps
) {
  const { campaign, productValue } = props

  const points = Math.round((productValue / campaign.value) * campaign.points)
  const pointsText = singularOrPlural(points, 'ponto', 'pontos')

  return (
    <GInformativeText
      color="neutral.600"
      fontSize={['.875rem', '.938rem']}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      icon={IconLogoLivelo as any}
      showBorder
      text={`Acumule até ${points} ${pointsText}`}
      sx={{
        p: {
          marginTop: '0 !important',
          marginBottom: '0 !important',
        },
      }}
    />
  )
}
